import axios from 'axios'
import {apiBaseUrl} from '../../../helpers/UrlHelper'
import {loginToken} from '../../../helpers/LocalStorageHelper'
import {handleError, handleSuccess} from '../../../helpers/ErrorHelper'
import store from '../../../Store'
import {scrollToError} from '../../../helpers/ScrollHelper'
import {
    cancelMigrationTrackingFormDispatch,
    migrationTrackingFormServerValidationErrors
} from "../../../pages/internal-migration-tracking/form/MigrationTrackingForm-Action";

function _success(success) {
    return {type: 'UPDATE_MIGRATION_TRACKING_SUCCESS', success}
}

function _error(error) {
    return {type: 'UPDATE_MIGRATION_TRACKING_ERROR', error}
}

function _processing(processing) {
    return {type: 'UPDATE_MIGRATION_TRACKING_PROCESSING', processing}
}

function updateMigrationTracking(id) {
    return (dispatch, getState) => {

        let {migrationTrackingForm} = getState()
        dispatch(_success(null))
        dispatch(_error(null))
        dispatch(_processing(true))

        axios({
            url: apiBaseUrl(`admin/internal-migration-tracking/${id}`),
            method: 'put',
            dataType: 'json',
            data: migrationTrackingForm.data.payload,
            headers: {
                'Authorization': 'Bearer ' + loginToken()
            }
        })
            .then(function (res) {
                dispatch(_success(res))
                dispatch(_processing(false))
                handleSuccess(res)
                store.dispatch(cancelMigrationTrackingFormDispatch())

            }).catch(function (error) {
            dispatch(_error(error.response.data.message))
            dispatch(_processing(false))
            handleError(error)

            store.dispatch(cancelMigrationTrackingFormDispatch())
            if (error.response && error.response.status === 422) {
                store.dispatch(migrationTrackingFormServerValidationErrors(error.response.data.errors))
                scrollToError()
            }
        })
    }
}

export default updateMigrationTracking
